import styled from 'styled-components'

export const Main = styled.button`
  align-items: center;
  background-color: ${(props) => (props.secondary ? 'white' : 'var(--color-primary, #0039c5)')};
  border:${(props) => (props.secondary ? '1px solid color-mix(in srgb, var(--color-primary, #0039c5) 65%, white)' : 'none')};
  border-radius: 12px;
  color:${(props) => (props.secondary ? 'color-mix(in srgb, var(--color-primary, #0039c5) 65%, white)' : 'white')}; 
  display: flex;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  height: 48px;
  line-height: 20px;
  cursor: pointer;
  margin: 0 0 0 40em;

  img {
    margin-right: 8px;
  }
`
